export var FileUploadStatusType;
(function (FileUploadStatusType) {
    FileUploadStatusType["ALERT"] = "alert-filled-triangle";
})(FileUploadStatusType || (FileUploadStatusType = {}));
//# sourceMappingURL=FileUploadStatusType.js.map